import { Phone, Mail, MapPin, Coffee } from "lucide-react";
import { SITE } from "@/lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#2C2621] text-[#D4C3B3]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Coffee size={22} strokeWidth={1.5} className="text-[#D4C3B3]" />
            <span className="font-serif-display text-2xl font-semibold text-[#FAF7F2]">
              Kingston Coffee Co.
            </span>
          </div>
          <p className="leading-relaxed max-w-xs">
            Mobile coffee catering bringing artisanal espresso, paninis, and baked goods to
            events across {SITE.serviceArea}.
          </p>
        </div>

        <div>
          <h4 className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-5">
            Get in Touch
          </h4>
          <ul className="space-y-4">
            <li>
              <a href={SITE.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-[#FAF7F2] transition-colors">
                <Phone size={18} strokeWidth={1.5} /> {SITE.phone}
              </a>
            </li>
            <li>
              <a href={SITE.emailHref} data-testid="footer-email" className="flex items-center gap-3 hover:text-[#FAF7F2] transition-colors">
                <Mail size={18} strokeWidth={1.5} /> {SITE.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={18} strokeWidth={1.5} /> {SITE.location}
            </li>
          </ul>
        </div>

        <div>
          <h4 className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-5">
            Explore
          </h4>
          <ul className="space-y-3">
            {[
              ["Services", "#services"],
              ["How It Works", "#how-it-works"],
              ["Menu", "#menu"],
              ["About", "#about"],
              ["FAQ", "#faq"],
              ["Request a Quote", "#quote"],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="hover:text-[#FAF7F2] transition-colors">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#594D42]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-sm text-[#8B7B6B] flex flex-col sm:flex-row justify-between gap-2">
          <p>© {new Date().getFullYear()} The Kingston Coffee Company. All rights reserved.</p>
          <p>Proudly serving the Greater Puget Sound area.</p>
        </div>
      </div>
    </footer>
  );
};
